import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchEStoreHomePageList = ({commit}) => {
   
    commit('toggleLoadingState', true)
    axios.get('/eStoreHomePage/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setEStoreHomePageList', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const fetchEStoreHomePageData = ({commit}, payload) => {
   
    commit('toggleLoadingState', true)
    axios.post('/eStoreHomePage/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});
            }
    
            commit('setEStoreHomePageData', res.data.response) 
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetEStoreCategoryData')
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const submitEStoreHomePageData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/eStoreHomePage/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const deleteEStoreHomePageData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/eStoreHomePage/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchEStoreHomePageList')
            }
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreHomePage/actions.js